import { css } from '@/styled-system/css';

export const dropdownContentStyles = css.raw({
  'display': 'flex',
  'borderRadius': 'obj.soft',
  'flexDirection': 'column',
  'backgroundColor': 'Dropdown.Content.bg',
  'boxShadow': 'md',
  'position': 'relative',
  'overflow': 'hidden',

  '& > [data-c11n-component="Dropdown.Header"]:first-child > [data-c11n-component="Dropdown.Heading"]':
    {
      borderStartStartRadius: 'obj.soft',
      borderStartEndRadius: 'obj.soft',
    },
});

export const dropdownContentPositionerStyles = css.raw({
  zIndex: 'dropdown',
});
